var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#145CC5",
    d: "M9 2.164c3.767 0 6.833 3.067 6.833 6.833S12.767 15.831 9 15.831s-6.833-3.067-6.833-6.834S5.233 2.164 9 2.164m0-1.5A8.336 8.336 0 0 0 .667 8.997c0 4.6 3.733 8.334 8.333 8.334s8.333-3.734 8.333-8.334S13.6.664 9 .664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#145CC5",
    d: "m9.732 7.801.346 5.535H7.945L8.29 7.8zm-.738-3.067q.472 0 .807.323.323.323.323.784 0 .45-.334.773a1.1 1.1 0 0 1-.796.322q-.461 0-.784-.322a1.04 1.04 0 0 1-.334-.773q0-.461.334-.784.323-.323.784-.323"
  })));
};
export default SvgInfoIcon;